import ComingSoon from 'Components/ComingSoon'

const Results = () => {
  return <ComingSoon />
}

export default Results
